import { Divider, LoadingOverlay, Paper, PaperProps, Title } from '@mantine/core';
import React from 'react';

import ErrorAlert from '@/components/ErrorAlert';

type PaperSectionProps = React.PropsWithChildren<
  {
    loading: boolean;
    title: string | React.ReactNode;
    error?: string;
  } & PaperProps
>;

const PaperSection: React.FC<PaperSectionProps> = ({
  loading,
  error,
  children,
  title,
  ...props
}) => (
  <Paper withBorder pos="relative" {...props}>
    <LoadingOverlay visible={loading} />
    <Title order={6} m="xs" tt="uppercase">
      {title}
    </Title>
    <Divider />
    {error ? <ErrorAlert>{error}</ErrorAlert> : null}
    {children}
  </Paper>
);

export default PaperSection;
